import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request'

// 获取活动赛事会员的二维码
export const apiGetProgramCode = data => {
  return axios.request({
    url: '/admin/get-min-code',
    method: 'post',
    data,
  })
}